export default __webpack_public_path__ + "static/media/linkdin.367e73f5.png";